import { PremioSorteioModel, MunicipioModel } from '../index';
import { ConsumidorModel } from '../../restrito/consumidor/shared/index';


export class RelacaoGanhadoresSorteio {
  seqSorteioPremiacaoConsumidor: number;
  desSorteioPremiacaoConsumidor: string;
  codSituacaoSorteioPremiacaoConsumidor: number;
  codTipoSorteioPremiacaoConsumidor: number;
  desTipoSorteioPremiacaoConsumidor: string;
  dataFinalPeriodo: Date;
  dataInicioPeriodo: Date;
  codBilhete: number;
  premioSorteioPremiacaoConsumidors: PremioSorteioModel[];
  consumidor: ConsumidorModel;
  municipio: MunicipioModel;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/relacao-ganhador-sorteio.model.ts